"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPeriodicSummaryPerformanceCreative = exports.createPeriodicSummaryPerformanceBasis = exports.createPeriodicSummaryPerformance = void 0;
const creation_1 = require("../creation");
const PerformanceValue_1 = require("../DailyPerformanceValue/PerformanceValue");
const performanceReportPeriod_1 = require("./performanceReportPeriod");
const createPeriodicSummaryPerformance = (object = {
    period: performanceReportPeriod_1.createPerformanceReportPeriod(),
    metric: 'click_through_rate',
    basis: exports.createPeriodicSummaryPerformanceBasis(),
    creatives: [exports.createPeriodicSummaryPerformanceCreative()],
}) => object;
exports.createPeriodicSummaryPerformance = createPeriodicSummaryPerformance;
const createPeriodicSummaryPerformanceBasis = (object = {
    actualValue: PerformanceValue_1.createPerformanceValue(),
}) => object;
exports.createPeriodicSummaryPerformanceBasis = createPeriodicSummaryPerformanceBasis;
const createPeriodicSummaryPerformanceCreative = (object = {
    creativeId: '',
    actualValue: PerformanceValue_1.createPerformanceValue(),
    improvementRate: 1,
    creation: creation_1.createSomeCreation(),
    adName: '',
    thumbnailImageUrl: '',
}) => object;
exports.createPeriodicSummaryPerformanceCreative = createPeriodicSummaryPerformanceCreative;
